module.exports = __webpack_public_path__ + "static/media/huiyuan.83151a9e.png";